import { render, staticRenderFns } from "./OnsiteCourse.vue?vue&type=template&id=234e59a3&scoped=true"
import script from "./OnsiteCourse.vue?vue&type=script&lang=js"
export * from "./OnsiteCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234e59a3",
  null
  
)

export default component.exports